import React, { useState, useEffect } from "react";
import Helmet from "../components/Helmet/Helmet";
import { Link } from "react-router-dom";

import "../styles/home.css";
import HomeDetails from "../components/HomeDetails/homeDetails";
import ImageTextbox from "../components/ImageTextbox/imageTextbox";

import tigerFighting from "../assets/images/tigerFighting.jpg";
import neluma from "../assets/images/neluma.webp";
import wildCapture from "../assets/images/wildCapture.jpg";
import RAJ_5713 from "../assets/images/RAJ_5713-copy-2-2048x1209.jpg";
import DSC_6730 from "../assets/images/DSC_6730-2-copy-2.jpg";
import mobile_18 from "../assets/images/mobile-18-1536x882.png.webp";
import arrow from "../assets/icons/arrow-right-s-line.svg";

import tiktokIcon from "../assets/icons/tiktok.svg";
import facebookIcon from "../assets/icons/facebook.svg";
import instaIcon from "../assets/icons/instagram.svg";

import carousel_1 from "../assets/images/carousel-1.jpg";
import carousel_2 from "../assets/images/carousel-2.jpg";
import carousel_3 from "../assets/images/carousel-3.jpg";
import carousel_4 from "../assets/images/carousel-4.jpg";

import hero_category_1 from "../assets/images/hero-category1.webp";
import hero_category_2 from "../assets/images/hero-category2.webp";
import hero_category_3 from "../assets/images/hero-category3.webp";
import hero_category_4 from "../assets/images/hero-category4.webp";
import hero_category_5 from "../assets/images/hero-category5.webp";

import hero_aboutImg from "../assets/images/about-section.webp";

import closeIcon from "../assets/icons/close.svg";
import heroAbout from "../assets/images/hero-about.png";

const Home = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const slides = [
    {
      img: carousel_1,
      category: "About Me",
      title:
        "Nature nerd by day, photo magician by night. Join me on wild adventures!",
      link: "/about",
    },
    {
      img: carousel_2,
      category: "Wildlife Safaris",
      title:
        "Leopard Safaris & Beyond: Dive into Sri Lankas rich tapestry of life.",
      link: "/safaris",
    },
    {
      img: carousel_3,
      category: "Prints",
      title:
        "Natures Masterpieces: Bring the essence of Sri Lanka into your home.",
      link: "/prints",
    },
    {
      img: carousel_4,
      category: "Portfolio",
      title: "Capturing the Untamed: Witness the raw beauty of Sri Lanka.",
      link: "/portfolio",
    },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prevSlide) => (prevSlide + 1) % slides.length);
    }, 5000);

    return () => clearInterval(interval); // Clear interval on component unmount
  }, [slides.length]);

  const handleNextSlide = () => {
    setCurrentSlide((prevSlide) => (prevSlide + 1) % slides.length);
  };

  const handlePrevSlide = () => {
    setCurrentSlide(
      (prevSlide) => (prevSlide - 1 + slides.length) % slides.length
    );
  };

  const handleSlideChange = (index) => {
    setCurrentSlide(index);
  };

  //category carousel

  const categories = [
    { img: hero_category_5, name: "All" },
    { img: hero_category_1, name: "Monochrome" },
    { img: hero_category_2, name: "Favourites" },
    { img: hero_category_3, name: "Animal Portrait" },
    { img: hero_category_4, name: "Golden Moments" },
  ];

  const [index, setIndex] = useState(0);
  const categoriesPerView = 4;

  const handleLeftClick = () => {
    if (index > 0) {
      setIndex(index - 1);
    }
  };

  const handleRightClick = () => {
    if (index < categories.length - categoriesPerView) {
      setIndex(index + 1);
    }
  };

  // Display hero section category menu
  const [showCategoryCarousel, setShowCategoryCarousel] = useState(false);
  const toggleCategoryCarousel = () => {
    setShowCategoryCarousel(!showCategoryCarousel);
    setShowHeroAbout(false);
  };

  // Display hero section about menu
  const [showHeroAbout, setShowHeroAbout] = useState(false);
  const toggleShowHeroAbout = () => {
    setShowHeroAbout(!showHeroAbout);
    setShowCategoryCarousel(false);
  };

  return (
    <>
      <Helmet title={"Home"}>
        <section className="hero__section __black">
          <div className="w fsba">
            <div className="hero__section-socialmedia">
              <div className="hero__section-socialmedia-main">
                <Link
                  target="_blank"
                  href="https://web.facebook.com/ravisarajayamannawildlifephotography"
                >
                  <span className="socialMedia-links hero__section-link">
                    <img
                      className="socialMedia__icons"
                      src={facebookIcon}
                      alt=""
                    />
                    facebook
                  </span>
                </Link>
                <span className="hero__section-dot"></span>
                <Link
                  target="_blank"
                  href="https://www.tiktok.com/@ravisara.jayamanna"
                >
                  <span className="socialMedia-links hero__section-link">
                    <img
                      className="socialMedia__icons"
                      src={tiktokIcon}
                      alt=""
                    />
                    tiktok
                  </span>
                </Link>
                <div className="hero__section-dot"></div>
                <Link
                  target="_blank"
                  href="https://www.instagram.com/ravisara.jayamanna/"
                >
                  <span className="socialMedia-links hero__section-link">
                    <img
                      className="socialMedia__icons"
                      src={instaIcon}
                      alt=""
                    />
                    instagram
                  </span>
                </Link>
              </div>
            </div>
            <div className="hero__carousel-container">
              <div
                className={`hero__category-container ${
                  showCategoryCarousel ? "open" : ""
                }`}
              >
                <div
                  class="hero__category-carousel"
                  style={{ transform: `translateX(-${index * 25}%)` }}
                >
                  {categories.map((category, i) => (
                    <Link
                      key={i}
                      className="hero__category-link"
                      to={`/portfolio?category=${category.name
                        .toLowerCase()
                        .replace(" ", "")}`}
                    >
                      <div className="opacity__layer"></div>
                      <img src={category.img} alt={category.name} />
                      <span className="hero-category-name">
                        {category.name}
                      </span>
                    </Link>
                  ))}
                </div>
                <div className="hero__category-arrows">
                  <img
                    className="hero__carousel-leftArrow"
                    src={arrow}
                    alt="Previous"
                    onClick={handleLeftClick}
                  />
                  <img
                    className="hero__carousel-rightArrow"
                    src={arrow}
                    alt="Next"
                    onClick={handleRightClick}
                  />
                </div>
              </div>
              <div
                className={`hero__section-about ${showHeroAbout ? "open" : ""}`}
              >
                <div className="hero__section-about-wrap">
                  <img
                    className="hero__section-aboutImg"
                    src={hero_aboutImg}
                    alt=""
                  />
                </div>
                <div className="hero__section-aboutContent">
                  <span>About Me</span>
                  <h1>Hello ! I'm Ravisara Jayamanna</h1>
                  <p>
                    I am 24 years old. I joined to the photography field in
                    2017. That was after joining the photography association of
                    that school. Out of curiosity about animals and travelling,
                    I turned to the wildlife photography side. My goal is to
                    give some knowledge to the society by taking pictures of
                    rare and elusive fauna which are important for the
                    conservation of biodiversity in Sri Lanka. I usually visit
                    mainly Yala, Wilpattu, Horton Plains and rainforests like
                    Sinharaja and Kitulgala.
                  </p>
                  <Link target="_blank" to="/about">
                    Read More &gt;
                  </Link>
                  <img
                    className="hero__section-aboutContent-bold"
                    src={heroAbout}
                    alt=""
                  />
                </div>
              </div>

              <div className="hero__carousel-item">
                <img
                  className="hero__carousel-img"
                  src={slides[currentSlide].img}
                  alt={slides[currentSlide].title}
                />
                <div className="hero__carousel-details">
                  <span>{slides[currentSlide].category}</span>
                  <h2>{slides[currentSlide].title}</h2>
                  <Link to={slides[currentSlide].link}>
                    Read More
                    <img
                      className="hero__carousel-readmore"
                      src={arrow}
                      alt="read more"
                    />
                  </Link>
                </div>
              </div>

              <div className="hero__carousel-arrows">
                <img
                  className="hero__carousel-leftArrow"
                  src={arrow}
                  alt="Previous"
                  onClick={handlePrevSlide}
                />
                <img
                  className="hero__carousel-rightArrow"
                  src={arrow}
                  alt="Next"
                  onClick={handleNextSlide}
                />
              </div>
              <div className="hero__carousel-counter">
                {slides.map((_, index) => (
                  <span
                    key={index}
                    className={currentSlide === index ? "active__carousel" : ""}
                    onClick={() => handleSlideChange(index)}
                  >
                    0{index + 1}
                  </span>
                ))}
              </div>
            </div>
            <div className="hero__section-category">
              <span
                className={showHeroAbout ? "clicked" : ""}
                onClick={toggleShowHeroAbout}
              >
                {showHeroAbout ? (
                  <>
                    <img
                      className="close__cat"
                      src={closeIcon}
                      alt="close menu"
                    />{" "}
                    Close
                  </>
                ) : (
                  "About"
                )}
              </span>
              <div className="hero__section-category-dot"></div>
              <span
                className={showCategoryCarousel ? "clicked" : ""}
                onClick={toggleCategoryCarousel}
              >
                {showCategoryCarousel ? (
                  <>
                    <img
                      className="close__cat"
                      src={closeIcon}
                      alt="close menu"
                    />{" "}
                    Close
                  </>
                ) : (
                  "Categories"
                )}
              </span>
            </div>
          </div>
        </section>
        <section className="home__details">
          <div className="w">
            <HomeDetails
              imageSrc={tigerFighting}
              title="Wildlife Photographic Safaris"
              content="We’re experts at arranging special trips and tours in beautiful Sri Lanka. We work closely with top-notch drivers to ensure a safe and unforgettable experience. Our wildlife safaris are carefully planned for photographers of all levels, even if you’re not a pro. We’ve been hosting aspiring photographers for over four years and are proud of their accomplishments."
              style={{ marginBottom: "30px" }}
            />
            <HomeDetails
              imageSrc={neluma}
              title="Fine Art Prints"
              content="I create beautiful photographs that are perfect for decorating your walls with style. These stunning pictures come in both regular and limited editions, and they showcase the beauty of nature in vibrant colors or classic black and white. Each print is carefully made on high-quality paper to ensure it lasts a long time and maintains its excellent quality for years. I focus on capturing wildlife authentically without using digital alterations, so the photos reflect the real moments as they happened, just like traditional photography."
              style={{ flexDirection: "row-reverse", marginBottom: "5px" }}
            />
          </div>
          <p className="homeDetails__text">
            “Animals can’t express their concerns, but as wildlife enthusiasts,
            we can be their voice and advocate for their well-being.”
          </p>
          <ImageTextbox
            image={wildCapture}
            text="“Captured at Kumana National Park, where tranquility meets ancient beauty. A graceful female leopard gazes at us, her majestic presence echoing the serenity of this peaceful haven.”"
          />
          <ImageTextbox
            image={RAJ_5713}
            text="“Majestic water buffalos frolic in morning waters, captured this stunning silhouette bathed in golden light. Taken at Kumana National Park.”"
          />
          <div className="homeFinal__main">
            <img src={DSC_6730} alt="" />
            <div className="w homeFinal__content-main">
              <p className="homeFinal__content">
                Explore the wonders of Sri Lankan wildlife with us! Join our
                journey through lush forests, encountering fascinating flora &
                fauna. Together with my friends, we’re on a mission to spark
                conversation and raise awareness. Subscribe and Join with us !
              </p>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.youtube.com/@wildserendib5042"
                className="homeFinal__link"
              >
                Click Here
              </a>
            </div>
            <img className="homeFinal__image" src={mobile_18} alt="" />
          </div>
        </section>
      </Helmet>
    </>
  );
};

export default Home;
